import styles from "./devoteeManagement.module.scss";
import { Box, FormControl, Grid, Typography } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import DeleteIcon from "../../assets/svg/delete_outline.svg";
import constants from "../../config/constants.json"
import { useEffect, useState } from "react";
import {
  CommonButton,
  CommonOutlinedButton,
  CustomCloseIcon,
  CustomInputLabel,
  CustomMenuItem,
  CustomSelect,
  CustomSelectforPooja,
} from "../common/StyledComponents/StyledFields";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import {
  apiRequest,
  catchErrorMessageHandler,
} from "../../infrastructure/backendService";
import apiPath from "../../config/apiPaths.json";
import ToastError from "../common/toast/toastError";
import toast, { Toaster } from "react-hot-toast";
import { ClipLoader } from "react-spinners";
import ToastSuccess from "../common/toast/toastSuccess";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import Pagination from "../common/pagination/pagination";
import LOCALE from '../../config/en-us.json';
import SuccessPopup from "../devotee/donation/successPopup";
import ErrorPopup from "../common/ErrorPopup";
import { isNil } from "lodash";

const DeletedDevoteeList = (): JSX.Element => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [selectedUsername, setSelectedUsername] = useState<
    string | null | undefined
  >(null);
  const [allData, setAllData] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [openEditPopUp, setEditPopUp] = useState<boolean>(false);
  const [openDeletepopUp, setDeletepopUp] = useState<boolean>(false);
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [pageSize, setPageSize] = useState<number>(25);
  const itemsPerPageList = [25, 30, 35, 40, 45, 50];
  const [showTableData, setShowTableData] = useState<boolean>(false);

  useEffect(() => {
    getAllData();
  }, [pageSize,pageNumber]);

  const getAllData = () => {
    setShowTableData(false);
    apiRequest({
      method: "GET",
      endpoint: apiPath.getDeleteDevotees,
      includeToken: true,
      params: {
        softDeletedOnly: true,
        page: pageNumber - 1,
        size: pageSize,
      },
    })
      .then((res) => {
        console.log(res.data, "restore");
        setAllData(res.data.content);
        setShowTableData(true);
        setTotalRecords(res.data.totalElements);
      })
      .catch((err) => {
        console.log(err);
        toast.custom(<ErrorPopup showMessage={catchErrorMessageHandler(err)} isOpen={isOpen} setIsOpen={setIsOpen} />, {
          duration: constants.TOAST_POPUP_DURATION,
        });
      });
  };

  const restoreApiCall = () => {
    setLoading(true);
    const reqbody = {
      usernames: [selectedUsername],
    };
    apiRequest({
      method: "PUT",
      endpoint: apiPath.restoreDevotee,
      includeToken: true,
      body: JSON.stringify(reqbody),
    })
      .then((res) => {
        setLoading(false);
        setEditPopUp(false);
        console.log(res.data, "restore");
        setSelectedUsername("");
        // toast.custom(<ToastSuccess message={LOCALE.DEVOTEE_LIST_RESTORED_SUCCESS} />);
        toast.custom(<SuccessPopup headerMessage="Devotee List" showMessage={LOCALE.DEVOTEE_LIST_RESTORED_SUCCESS} isOpen={isOpen} setIsOpen={setIsOpen} />,
        {
          duration: constants.TOAST_POPUP_DURATION,
        });
        getAllData();
      })
      .catch((err) => {
        setLoading(false);
        setSelectedUsername("");
        console.log(err);
        toast.custom(<ErrorPopup showMessage={catchErrorMessageHandler(err)} isOpen={isOpen} setIsOpen={setIsOpen} />, {
          duration: constants.TOAST_POPUP_DURATION,
        });
      });
  };

  const handleClose = () => {
    setDeletepopUp(false);
    setEditPopUp(false);
    setSelectedUsername(null);
  };

  const handleDelete = () => {
    setLoading(true);
    apiRequest({
      method: "DELETE",
      endpoint: apiPath.getDeleteDevotees,
      includeToken: true,
      params: {
        usernames: [selectedUsername],
      },
    })
      .then((res) => {
        console.log(res.data, "Delete");
        setLoading(false);
        setDeletepopUp(false);
        setSelectedUsername("");
        getAllData();
        // toast.custom(<ToastSuccess message={LOCALE.DEVOTEE_LIST_DELETED_SUCCESS} />);
        toast.custom(<SuccessPopup headerMessage="Devotee List" showMessage={LOCALE.DEVOTEE_LIST_DELETED_SUCCESS} isOpen={isOpen} setIsOpen={setIsOpen} />,
        {
          duration: constants.TOAST_POPUP_DURATION,
        });
      })
      .catch((err) => {
        console.log(err);
        setSelectedUsername("");
        setLoading(false);
        toast.custom(<ErrorPopup showMessage={catchErrorMessageHandler(err)} isOpen={isOpen} setIsOpen={setIsOpen} />, {
          duration: constants.TOAST_POPUP_DURATION,
        });
      });
  };

  const editDialogPopup = () => {
    return (
      <Dialog
        open={openEditPopUp}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          style: {
            height: "calc(100% - 128px)",
            width: "calc(100% - 128px)",
            margin: "64px",
            maxWidth: "504px",
            maxHeight: "180px",
            borderTopLeftRadius: "16px",
            borderTopRightRadius: "16px",
          },
        }}
      >
        <DialogTitle className={styles.dialogTitle}>
          {"Please Confirm"}

          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 24,
              top: 12,
              color: (theme: any) => theme.palette.grey[500],
            }}
          >
            <CloseIcon sx={{ color: "white" }} />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            id="alert-dialog-slide-description"
            className={styles.dialogContext}
          >
            Are You Sure want to Restore the {selectedUsername} User ?
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <CommonOutlinedButton onClick={handleClose}>No</CommonOutlinedButton>
          <CommonButton onClick={restoreApiCall} disabled={loading}>
            {loading ? (
              <>
                <ClipLoader color="#fff" loading={loading} size={15} />
                <span
                  style={{
                    marginLeft: "8px",
                    fontSize: "15px",
                    textAlign: "center",
                  }}
                >
                  Restoring...
                </span>
              </>
            ) : (
              "Yes"
            )}
          </CommonButton>
        </DialogActions>
      </Dialog>
    );
  };

  const deleteDialogPopup = () => {
    return (
      <Dialog
        open={openDeletepopUp}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          style: {
            height: "calc(100% - 128px)",
            width: "calc(100% - 128px)",
            margin: "64px",
            maxWidth: "504px",
            maxHeight: "180px",
            borderTopLeftRadius: "16px",
            borderTopRightRadius: "16px",
          },
        }}
      >
        <DialogTitle className={styles.dialogTitle}>
          {"Please Confirm"}

          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 24,
              top: 12,
              color: (theme: any) => theme.palette.grey[500],
            }}
          >
            <CloseIcon sx={{ color: "white" }} />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            id="alert-dialog-slide-description"
            className={styles.dialogContext}
          >
            Are You Sure want to Delete the {selectedUsername} User ?
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <CommonOutlinedButton onClick={handleClose}>No</CommonOutlinedButton>
          <CommonButton onClick={handleDelete} disabled={loading}>
            {loading ? (
              <>
                <ClipLoader color="#fff" loading={loading} size={15} />
                <span
                  style={{
                    marginLeft: "8px",
                    fontSize: "15px",
                    textAlign: "center",
                  }}
                >
                  Deleting...
                </span>
              </>
            ) : (
              "Yes"
            )}
          </CommonButton>
        </DialogActions>
      </Dialog>
    );
  };

  const openConfirmPopUp = (id: string | undefined | null, type: string) => {
    setSelectedUsername(id);
    if (type === "restore") {
      setEditPopUp(true);
      setDeletepopUp(false);
    } else {
      setEditPopUp(false);
      setDeletepopUp(true);
    }
  };

  const itemPerPageDropdown = (): React.ReactElement => {
    const handleChangePageSize = (e: any) => {
      setPageSize(e.target.value);
    };

    return (
      <FormControl
        sx={{
          width: "100%",
          border: "1px solid rgba(136, 46, 20, 0.40)",
          borderRadius: "8px",
        }}
      >
        <CustomSelectforPooja
          IconComponent={KeyboardArrowDownIcon}
          id="grouped-select"
          onChange={handleChangePageSize}
          value={pageSize}
          MenuProps={{
            PaperProps: {
              sx: {
                border: "1px solid #F05802",
                "& ul": {
                  paddingTop: 0,
                  paddingBottom: 0,
                  overflowY: "auto",
                  minHeight: "auto",
                  maxHeight: "300px",
                  "&::-webkit-scrollbar": {
                    width: "8px",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    background: "#F3C539",
                    borderRadius: "6px",
                  },
                },
              },
            },
          }}
        >
          {itemsPerPageList.map((item: number, i: number) => (
            <CustomMenuItem value={item} key={i}>
              {item}
            </CustomMenuItem>
          ))}
        </CustomSelectforPooja>
      </FormControl>
    );
  };

  const renderTableComponent = () => {
    return (
      <>
        <div>
          <table className={styles.tableContainer}>
            <thead>
              <tr className={styles.headerTableRow}>
                <th
                  className={styles.tableHorizontal}
                  style={{ padding: "12px" }}
                >
                  Name
                </th>
                <th
                  className={styles.tableHorizontal}
                  style={{
                    float: "right",
                    paddingRight: "160px",
                    position: "relative",
                    top: "5px",
                  }}
                >
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className={styles.tableBody}>
              {allData.map((row, id) => (
                <tr
                  key={id}
                  className={styles.tableRow}
                  style={{ padding: "12px" }}
                >
                  <td
                    className={styles.tableDiagonal}
                    style={{ padding: "12px" }}
                  >
                    {/* {row.username} */}
                    {!isNil(row.firstname) && !isNil(row.lastname) && (row.firstname.trim() !== '' || row.lastname.trim() !== '') ? <>{row.firstname} {row.lastname}</> : "- -"}

                  </td>
                  <td className={styles.restoreDeleteButtons}>
                    <IconButton sx={{ display: "flex", gap: "8px" }} onClick={() => openConfirmPopUp(row.username, "restore")} >
                      <img
                        src="/images/restore.svg"
                        className={styles.Image}
                      />
                      <Typography className={styles.Restore} component={"p"} sx={{color:"black"}}>
                        Restore
                      </Typography>
                    </IconButton>
                    <IconButton sx={{ display: "flex", gap: "8px" }} disabled={true}>
                      <img
                        src={DeleteIcon}
                        className={styles.DeleteIcon}
                        onClick={() => openConfirmPopUp(row.username, "delete")}
                        aria-disabled={true}
                      />
                      <Typography className={styles.Restore}>Delete</Typography>
                    </IconButton>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {/* {totalRecords > pageSize ? ( */}
          <div
            style={{
              display: "flex",
              justifyContent: "end",
              marginRight: "10px",
              marginTop: "20px",
              gap: "10px",
              marginLeft: "auto",
            }}
          >
            <Grid item xs={12} sm={4}>
              <div style={{ width: "100%", marginBottom: "20px" }}>
                <CustomInputLabel>Items Per Page</CustomInputLabel>
                {itemPerPageDropdown()}
              </div>
            </Grid>
            <Pagination
              items={totalRecords}
              itemsPerPage={pageSize}
              setPageNumber={setPageNumber}
              pageNumber={pageNumber}
            />
          </div>
        {/* ) : (
          ""
        )} */}
      </>
    );
  };

  const showTableComponent = () => {
    return (
       <>
       {totalRecords > 0 ? renderTableComponent() : <Typography sx={{textAlign:"center"}}>No Records found.</Typography>}
       </>
    )
   }

  return (
    <Box className={styles.DeletedDevoteeList}>
      <Toaster />
      <Typography className={styles.SubHeading}>
        Deleted Devotee List
      </Typography>
      {showTableData ?  showTableComponent() : ""}
      {editDialogPopup()}
      {deleteDialogPopup()}
    </Box>
  );
};

export default DeletedDevoteeList;
